const copia_ensino_ministrado = {
  path: "/copia-de-ensino-ministrado",
  redirect: "/copia-de-ensino-ministrado",
  meta: {
    breadCrumb: "Planejamento Matricula - Tabelas de Apoio ao Planejamento",
  },
  children: [
    {
      path: "/copia-de-ensino-ministrado",
      name: "copia-de-ensino-ministrado",
      meta: {
        allowedPermissions: ["ensino_ministrado_copiar"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CopiaDeEnsinoMinistrado/CopiaDeEnsinoMinistradoHome.vue"
        ),
    },
  ],
};

export { copia_ensino_ministrado };
